/**
 * Fixed strings of the sidebar short form and the collapsed chip.
 * The approved mock (.design/launch-activation/mockups/activation-sidebar.html)
 * is Russian and defines MEANING only — every shipped string here is English
 * (D-R1 / AM-4 / AM-14: all product copy is English regardless of mock language).
 * Item titles / details / action labels come from the server projection
 * (Plan B `launchActivationCopy.ts`) — never duplicated here.
 */
export const SHORT_FORM_COPY = {
  title: 'Launch',
  count: (earned: number, total: number): string => `${earned} of ${total}`,
  chip: (earned: number, total: number): string => `${earned} / ${total}`,
  chipComplete: 'Done',
  complete: 'Everything is ready to launch',
  allSteps: 'All steps',
  actionVerb: { P: 'Open', C: 'Open', D: 'Set up', X: 'Go to' } as const,
  landing: {
    C: 'Opens the canvas with the Deploy Web button highlighted.',
    D: 'Opens right here — no page change.',
    P: (label: string): string => `Opens the page: ${label}.`,
    X: (label: string): string => `Opens an external site: ${label}.`,
  },
} as const;
